import { Injectable } from '@angular/core';

@Injectable()
export class SharedPdfService {

  constructor() { }

  /**
   * fomart the out put of dollar values
   * @param value
   */
  commaPipe(value: string): string {
    let breakPoint = 5;
    if (value.length == 0) {
      return '';
    }
    if (typeof value != 'number') {
      breakPoint = value.indexOf('-') != -1 ? 6 : 5;
    }
    // console.log(value, breakPoint);
    var str = value.toString().split('.');
    if (str[0].length >= breakPoint) {
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      str[1];
    }
    if (str[1]) {
      str[1] = str[1].substr(0, 2);
    }
    // return str.join('.');
    return '$' + str.join('.');
  }

  /**
   * out put same formart date : DD-MM-YYYY
   * @param dateo
   */
  dateformat(dateo: string): string {
    //console.log(dateo, typeof dateo, dateo == " ");

    let datearray = dateo.split('-');

    let ret = '';
    if (dateo == '') {
      ret = '';
    } else {
      //console.log("do i come in side ?");
      ret = datearray[2] + '-' + datearray[1] + '-' + datearray[0];
    }
    if (ret != '') {
      if (ret.indexOf('undefined') != -1) {
        return '';
      } else {
        return ret;
      }
    } else {
      return ret;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared/shared-pdf.service.ts